<template>
  <div class="data-grid-data-select">
    <el-select v-if="pageable"
               v-model="selectValue"
               :multiple="multiProp"
               :filterable="true"
               clearable
               :placeholder="column.name"
               :loading="loading"
               loading-text="数据加载中..."
               no-match-text="没有匹配数据"
               popper-class="data-grid-data-select-popper"
               :filter-method="filterGridSelectPageData"
               @visible-change="selectPopoverVisibleChange"
               style="width: 100%">
      <!-- 用来保证有数据 -->
      <el-option key="default__option"
                 label=""
                 value=""
                 class="hidden-option"></el-option>
      <template v-if="columnOptions">
        <el-option v-for="option in columnOptions"
                   :key="option.propKey || option.propValue"
                   :label="option.propLabel"
                   :value="option.propValue">
        </el-option>
      </template>
      <div v-show="!loading">
        <div class="el-select-dropdown__empty" v-if="!columnOptions">
          <span>数据获取失败<a class="theme-text" href="javascript:;" @click="loadGridSelectPageData">重新加载</a></span>
        </div>
        <div class="el-select-dropdown__empty" v-else-if="columnOptions.length === 0">
          <span>返回数据为空</span>
        </div>
      </div>
      <el-pagination
        small
        :page-size.sync="pageSize"
        :current-page.sync="pageIndex"
        :total="totalCount"
        :pager-count="pagerCount"
        layout="prev, pager, next, ->, total"
        @size-change="paginationPageChange"
        @current-change="paginationPageChange">
      </el-pagination>
    </el-select>
    <el-select v-else
               v-model="selectValue"
               :multiple="multiProp"
               :filterable="columnOptions && columnOptions.length > 0"
               clearable
               :placeholder="column.name"
               :loading="loading"
               loading-text="数据加载中..."
               no-match-text="没有匹配数据"
               @focus="expandGridSelectData"
               style="width: 100%">
      <!-- 用来保证有数据 -->
      <el-option key="default__option"
                 label=""
                 value=""
                 class="hidden-option"></el-option>
      <template v-if="columnOptions">
        <el-option v-for="option in columnOptions"
                   :key="option.propKey || option.propValue"
                   :label="option.propLabel"
                   :value="option.propValue">
        </el-option>
      </template>
      <div v-show="!loading">
        <div class="el-select-dropdown__empty" v-if="!columnOptions">
          <span>数据获取失败<a class="theme-text" href="javascript:;" @click="expandGridSelectData">重新加载</a></span>
        </div>
        <div class="el-select-dropdown__empty" v-else-if="columnOptions.length === 0">
          <span>返回数据为空</span>
        </div>
      </div>
    </el-select>
  </div>
</template>

<script>
import { getValueByPath } from 'element-ui/lib/utils/util'
import baseApiUrl from '../../../constants/baseApiUrl'
import routeConfig from '../../../constants/routeConfig'
export default {
  name: 'DataGridDataSelect',
  props: {
    value: {
      required: true
    },
    column: {
      type: Object,
      required: true
    },
    keyProp: {
      type: String
    },
    labelProp: {
      type: String,
      required: true
    },
    valueProp: {
      type: String,
      required: true
    },
    multiProp: {
      type: Boolean,
      default: false
    },
    refOptions: {
      default: () => {
        return []
      }
    },
    pageable: {
      type: Boolean
    }
  },
  data () {
    return {
      loading: false,
      fetched: false,
      optionList: null,
      pageIndex: 1,
      pageSize: 8,
      pagerCount: 5,
      totalCount: 0,
      query: null
    }
  },
  computed: {
    columnOptions: function () {
      let optionList = this.optionList
      if (!optionList) {
        if (Array.isArray(this.refOptions)) {
          optionList = this.refOptions
        }
      }
      if (optionList) {
        return optionList.map(option => {
          return {
            propKey: this.keyProp ? getValueByPath(option, this.keyProp) : null,
            propLabel: getValueByPath(option, this.labelProp || 'label'),
            propValue: getValueByPath(option, this.valueProp || 'value')
          }
        })
      }
    },
    selectValue: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('input', value)
      }
    }
  },
  methods: {
    // 展开下拉框
    expandGridSelectData () {
      if (!this.loading && !this.fetched) {
        let postParams = this.$extend(this.$attrs)
        if (!postParams[routeConfig.DataGrid.param]) {
          return
        }
        this.loading = true
        let params = this.$extend({
          requestType: 'dropDown',
          prop: this.column.prop
        }, postParams)
        this.$ajax({
          url: baseApiUrl.DataGridUrl,
          method: 'post',
          data: this.$qs.stringify(params, {
            arrayFormat: 'repeat'
          })
        }).then((response) => {
          if (response.data) {
            this.optionList = response.data['optionList']
            if (response.data['message'] && response.data['responseCode'] !== 'SUCCESS') {
              this.$message.error('下拉数据加载出错')
            }
          }
          this.fetched = true
        }).finally(() => {
          this.loading = false
        })
      }
    },
    // 加载分页数据
    loadGridSelectPageData () {
      let postParams = this.$extend(this.$attrs)
      if (!postParams[routeConfig.DataGrid.param]) {
        return
      }
      this.loading = true
      let params = this.$extend({
        requestType: 'dropDown',
        prop: this.column.prop,
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
        query: this.query || ''
      }, postParams)
      this.$ajax({
        url: baseApiUrl.DataGridUrl,
        method: 'post',
        data: this.$qs.stringify(params, {
          arrayFormat: 'repeat'
        })
      }).then((response) => {
        if (response.data) {
          this.optionList = response.data['optionList']
          this.totalCount = response.data['totalCount'] || 0
          if (response.data['message'] && response.data['responseCode'] !== 'SUCCESS') {
            this.$message.error('下拉数据加载出错')
          }
        }
      }).finally(() => {
        this.loading = false
      })
    },
    // 下拉框显示隐藏
    selectPopoverVisibleChange (visible) {
      if (visible) {
        this.loadGridSelectPageData()
      } else {
        this.query = null
      }
    },
    // 分页搜索
    filterGridSelectPageData (query) {
      this.query = query
      this.loadGridSelectPageData()
    },
    // 分页参数改变
    paginationPageChange () {
      this.loadGridSelectPageData()
    }
  },
  deactivated () {
    // 切换页面后重新加载
    this.fetched = false
  }
}
</script>

<style lang="scss">
  .data-grid-data-select {
    & > .el-select {
      width: 100%;
      .el-input--mini {
        .el-input__inner {
          height: 28px!important;
        }
      }
      .el-input--small {
        .el-input__inner {
          height: 32px!important;
        }
      }
      .el-input--medium {
        .el-input__inner {
          height: 36px!important;
        }
      }
    }
  }
  .el-select-dropdown {
    &.data-grid-data-select-popper {
      .el-select-dropdown__wrap {
        max-height: 350px!important;
      }
    }
    .el-select-dropdown__wrap {
      .el-select-dropdown__list {
        .el-select-dropdown__item {
          &.hidden-option {
            display: none;
          }
        }
        .el-pagination {
          margin: 6px 0 -6px;
          padding: 6px 4px;
          border-top: 1px solid rgba(0,0,0,.03);
          .el-pagination__rightwrapper {
            .el-pagination__total {
              font-size: 12px;
            }
          }
          .btn-prev,
          .btn-next {
            padding: 0 6px;
            background-color: transparent;
          }
          .el-pager {
            & > li {
              font-weight: normal;
              background-color: transparent;
            }
          }
        }
      }
    }
    .el-select-dropdown__empty {
      padding: 40px 0;
      a {
        margin: 0 4px;
        text-decoration: none;
      }
    }
  }
</style>
